import { render } from "./MInformToast.vue?vue&type=template&id=c972193e"
import script from "./MInformToast.vue?vue&type=script&lang=js"
export * from "./MInformToast.vue?vue&type=script&lang=js"

import "./MInformToast.vue?vue&type=style&index=0&id=c972193e&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__